import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAuthToken } from '../../../utils/auth';
//import axios from 'axios';
//import Candidates from '../../components/Organization/Candidates/Candidates';

// Async Thunks
export const fetchUsers = createAsyncThunk('adminUsers/fetchUsers', async () => {
   const token = getAuthToken();
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/admin/users',{
        headers: {
            'Content-Type':'application/json',
            'Authorization': `Bearer ${token}`,
          }, 
          method: 'GET',
    }); 
    return response.json(); 
});

// Slice
const adminUsersSlice = createSlice({
    name: 'adminUsers',
    initialState: {
        loading: false,
        users:   ([] as any[]),
        error: '',
        formErrors: []
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload.data;
                state.error = '';
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.loading = false;
                state.users = [];
                state.error = action.error.message + "";

            })
            
    }
});
export default adminUsersSlice.reducer;
